module.exports = __webpack_public_path__ + "7750265fbea52ae4af728bd6053243f4.svg";